if (!customElements.get('dropdown-menu')) {
  class DropdownMenu extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-dropdown-trigger]');
        if(!clickedElement) return;
        this.isOpen ? this.close() : this.open();
      });
      window.addEventListener('click', (e) => {
        if (!e.target.closest('dropdown-menu') && this.isOpen) {
          this.close();
        }
      })
    }

    close() {
      this.classList.remove('active');
      this.isOpen = false;
    }
    open() {
      this.classList.add('active');
      this.isOpen = true;
    }
  }

  customElements.define('dropdown-menu', DropdownMenu);
}

// Example:

// <dropdown-menu class="md:hidden relative z-1 [&.active_button]:rounded-b-none [&.active_button]:border-b-0 [&.active_ul]:block [&_.dropdown-icon]:rotate-90 [&.active_.dropdown-icon]:-rotate-90">
//   <button data-dropdown-trigger class="w-full h-14 flex justify-between items-center px-4 bg-primaryLight border border-stone rounded text-primaryDark font-bold">
//     <span class="mr-1">{{ page.title }}</span>
//     <span class="w-2 dropdown-icon transition-all duration-100">{% render 'icons' icon: 'chevron' %}</span>
//   </button>
//   <ul class="absolute hidden w-full bg-primaryLight border border-t-0 border-stone pb-2">
//     {% for block in section.blocks %}
//       <li class="">
//         <a class="hover:bg-lightStone text-primaryDark py-2 px-4 block whitespace-no-wrap" href="{{ block.url }}">{{ block.title }}</a>
//       </li>
//     {% endfor %}
//   </ul>
// </dropdown-menu>